export const GET_RISK_ASSESSMENT_LIST = "GET_RISK_ASSESSMENT_LIST";
export const GET_RISK_ASSESSMENT_LIST_SUCCESS = "GET_RISK_ASSESSMENT_LIST_SUCCESS";
export const GET_RISK_ASSESSMENT_LIST_FAIL = "GET_RISK_ASSESSMENT_LIST_FAIL";

export const ADD_RISK_ASSESSMENT_FILE = "ADD_RISK_ASSESSMENT_FILE";
export const ADD_RISK_ASSESSMENT_FILE_SUCCESS = "ADD_RISK_ASSESSMENT_FILE_SUCCESS";
export const ADD_RISK_ASSESSMENT_FILE_FAIL = "ADD_RISK_ASSESSMENT_FILE_FAIL";

export const DELETE_RISK_ASSESSMENT_FILE = "DELETE_RISK_ASSESSMENT_FILE";
export const DELETE_RISK_ASSESSMENT_FILE_SUCCESS = "DELETE_RISK_ASSESSMENT_FILE_SUCCESS";
export const DELETE_RISK_ASSESSMENT_FILE_FAIL = "DELETE_RISK_ASSESSMENT_FILE_FAIL";

export const UPDATE_STATUS = "UPDATE_STATUS";
export const UPDATE_STATUS_SUCCESS = "UPDATE_STATUS_SUCCESS";
export const UPDATE_STATUS_FAIL = "UPDATE_STATUS_FAIL";
